import { Component, Inject, OnInit } from '@angular/core';
import { ModalConfig } from '../../modal-config';
import { ModalRef } from '../../modal-ref';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ADJ_HISTORY_DATE_FORMAT } from '@app/main/forecast-runs/utils/common-variables';
import { isNotEmpty } from '@app/utils';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-override-history-modal',
    templateUrl: './override-history-modal.component.html',
    styleUrls: ['./override-history-modal.component.scss'],
    standalone: false
})
export class OverrideHistoryModalComponent implements OnInit {
  lastUpdated: string;
  public ref : MatDialogRef<OverrideHistoryModalComponent>

  constructor(
    public config: ModalConfig,
    public modal: ModalRef,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.translate.setDefaultLang('en-US');
  }

  ngOnInit() {
      this.config.data = this.data;
    if (isNotEmpty(this.config.data.overrideCellInfo)) {
      this.lastUpdated = moment(this.data.overrideCellInfo.lastUpdated).format(
        ADJ_HISTORY_DATE_FORMAT,
      );
    }
  }

  onClose(dischardChanges: boolean) {
    this.modal.close(dischardChanges);
  }

  discardChanges() {
    this.onClose(true);
  }

  doNotDiscardChanges() {
    this.onClose(false);
  }
}
